import { Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle, Plus } from 'react-feather'

import { ModalModule } from '../Modal'
import { CollateralTable } from './CollateralTable'
import { CollateralImages } from './CollateralImages/CollateralImages'

// import { LinearLoading } from 'common'

export const FormStepCollateral = ({ useFetchInit }) => {
  const { globalStates, Actions } = useFetchInit

  const { stepApplilication, formOpeningMode, showSection, contractLoaded } = globalStates
  const { handleClickReturnStep, handleClickNextStep, handleClickShowModal } = Actions

  const isReadOnly = !(formOpeningMode === 'EDITABLE' && !contractLoaded)
  const isHome = showSection === 'HOME'
  const isImage = showSection === 'IMAGE'
  return (
    <div className="content">
      {isHome && (
        <>
          <Button
            startIcon={<Plus />}
            variant="contained"
            sx={{ marginBottom: 4 }}
            color="primary"
            onClick={() =>
              handleClickShowModal(
                '',
                'Formulario de Garantias',
                'collateral-section',
                {},
                'EDITABLE'
              )
            }
            disabled={isReadOnly}
          >
            Agregar
          </Button>

          {/* {loadingFetchDeposits && <LinearLoading />} */}
          <CollateralTable useFetchInit={useFetchInit} />

          <ModalModule useFetchInit={useFetchInit} />

          <div className="text-center">
            {stepApplilication !== 0 && (
              <Button
                startIcon={<ArrowLeftCircle />}
                variant="contained"
                type="button"
                className="btn-round"
                color="warning"
                onClick={handleClickReturnStep}
                sx={{ marginTop: 2, marginRight: 1, marginLeft: 1 }}
              >
                Volver
              </Button>
            )}

            <Button
              endIcon={<ArrowRightCircle />}
              variant="contained"
              type="button"
              className="btn-round"
              color="primary"
              sx={{ marginTop: 2, marginRight: 1, marginLeft: 1 }}
              onClick={handleClickNextStep}
            >
              {stepApplilication === 4 ? 'Finalizar' : 'Continuar'}
            </Button>
          </div>
        </>
      )}
      {isImage && (
        <CollateralImages useFetchInit={useFetchInit} />
      )}
    </div>
  )
}
